import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  createNewReservationTableRequest,
  editReservationTableRequest,
  getReservationTableRequest,
  deleteReservationTableRequest,
  createNewRegionRequest,
  getRegionsRequest,
  editRegionRequest,
  deleteRegionRequest,
  getTouchsaleTablesPerRegionRequest,
  busyOrFreeTableRequest,
} from "../../services/restaurantSchemeService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* createNewReservationTable(newTableData) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(
      createNewReservationTableRequest,
      token,
      newTableData
    );
    if (response[0] === 200) {
      yield put({
        type: actions.CREATE_NEW_RESERVATION_TABLE_SUCCESS,
        table: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* editReservationTable(editTableData) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(
      editReservationTableRequest,
      token,
      editTableData
    );
    if (response[0] === 200) {
      yield put({
        type: actions.EDIT_RESERVATION_TABLE_SUCCESS,
        table: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* deleteReservationTable(deteleTableData) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(
      deleteReservationTableRequest,
      token,
      deteleTableData
    );
    if (response[0] === 200) {
      yield put({
        type: actions.DELETE_RESERVATION_TABLE_SUCCESS,
        table: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getReservationTable(regionId) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(getReservationTableRequest, token, regionId);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_RESERVATION_TABLE_SUCCESS,
        tables: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* createNewRegion(newRegionData) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(createNewRegionRequest, token, newRegionData);
    if (response[0] === 200) {
      yield put({
        type: actions.CREATE_NEW_REGION_SUCCESS,
        region: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getRegions() {
  try {
    const token = getToken().get("idToken");

    const response = yield call(getRegionsRequest, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_REGIONS_SUCCESS,
        regions: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* editReservationRegion(editRegionData) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(editRegionRequest, token, editRegionData);
    if (response[0] === 200) {
      yield put({
        type: actions.EDIT_REGION_SUCCESS,
        region: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* deleteReservationRegion(deleteRegionData) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(deleteRegionRequest, token, deleteRegionData);
    if (response[0] === 200) {
      yield put({
        type: actions.DELETE_REGION_SUCCESS,
        region: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getTouchsaleTablesPerRegion(getTouchsaleTablesData) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(
      getTouchsaleTablesPerRegionRequest,
      token,
      getTouchsaleTablesData
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_TOUCHSALE_TABLES_PER_REGION_SUCCESS,
        touchsaleTables: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* busyOrFreeTable(data) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(busyOrFreeTableRequest, token, data);
    if (response[0] === 200) {
      yield put({
        type: actions.BUSY_OR_FREE_TABLE_SUCCESS,
        editTable: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(
      actions.CREATE_NEW_RESERVATION_TABLE_REQUEST,
      createNewReservationTable
    ),
    yield takeEvery(
      actions.EDIT_RESERVATION_TABLE_REQUEST,
      editReservationTable
    ),
    yield takeEvery(
      actions.DELETE_RESERVATION_TABLE_REQUEST,
      deleteReservationTable
    ),
    yield takeEvery(actions.GET_RESERVATION_TABLE_REQUEST, getReservationTable),
    yield takeEvery(actions.CREATE_NEW_REGION_REQUEST, createNewRegion),
    yield takeEvery(actions.GET_REGIONS_REQUEST, getRegions),
    yield takeEvery(actions.EDIT_REGION_REQUEST, editReservationRegion),
    yield takeEvery(actions.DELETE_REGION_REQUEST, deleteReservationRegion),
    yield takeEvery(
      actions.GET_TOUCHSALE_TABLES_PER_REGION_REQUEST,
      getTouchsaleTablesPerRegion
    ),
    yield takeEvery(actions.BUSY_OR_FREE_TABLE_REQUEST, busyOrFreeTable),
  ]);
}
